import $ from 'jquery';
import '../../../js/select2-loader';

$(document).ready(function() {
    //$("#e1").select2();

    $('body').on('change','.checkbox__input',function(e){
        const isChecked = $(this).is(':checked');
        const text = $(this).prev().html();
        const value = $(this).val();
        const textHolder = $(this).closest('.multiselect').find('.text-holder');
        if(isChecked){
            const itemCount = $(textHolder).find('.multiselect-item').length;
            let buildedElement = "";
            if(itemCount >= 4){
                //add ... element
                let moreElement = $(textHolder).find(`.item-more`);
                if(moreElement.length == 0){
                    buildedElement = `<span class="multiselect-item item-more" data-text="...">...</span>`;
                }
            }else{
                buildedElement = `<span class="multiselect-item item-${value}" data-text="${text}"> ${itemCount > 0 ? ', ' : ''} ${text} </span>`;
            }
            $(textHolder).find('.base-text').addClass('d-none');
            $(textHolder).append(buildedElement)
        }else{
            const itemCount = $(textHolder).find('.multiselect-item').length;
            let moreElement = $(textHolder).find(`.item-more`);
            /* Remove item */
            $(textHolder).find(`.item-${value}`).remove();
            /* Check no more item */
            const childLength = $(textHolder).children().length;
            if(childLength === 1){
                $(textHolder).find('.base-text').removeClass('d-none');
            }

            //console.log(childLength)
            if(childLength === 2){
                $(textHolder).children().each(function(){
                    const currentContent = $(this).html().trim();
                    if(currentContent != 'Válasszon települést'){
                        $(this).html($(this).data('text'));
                    }
                });
            }

            //console.log("childlenght:" + childLength)
            if(moreElement.length > 0 && childLength <= 6){
                moreElement.remove()
            }
        }
    });


    $('#search-form').on('submit',function (e) {
        $('select option[value=""]:selected').closest("select").attr('name', '');
        let locationIds = [];

        /* Rental type management  */
        if ($(this).find("input[name=rentalFalse]").is(':checked')) {
            $('#rental').val(0);
            $(this).find("input[name=rentalFalse]").prop('name','')
        }
        if ($(this).find("input[name=rentalTrue]").is(':checked')) {
            $('#rental').val(1);
            $(this).find("input[name=rentalTrue]").prop('name','')
        }

        /*  District multi select manager  */
        $(this).find("input[name=districtsElements]").each(function() {
            if($(this).is(":checked")){
                locationIds.push($(this).val())
            }
            $(this).prop('name','')
        })

        if(locationIds.length !== 0 ){
            $('#districtsInput').val(locationIds.join(','));
        }else{
            $('#districtsInput').prop('name','')
        }

        let array = ['rental', 'districtsInput', 'minPriceFilter', 'maxPriceFilter', 'minSizeFilter', 'maxSizeFilter'];
        /* Remove empty input names*/
        $(this)
            .find('input')
            .filter(function () {
                return !this.value && array.includes(this.id);
            })
            .attr('disabled', 'disabled');

        //e.preventDefault();
    });

    $('#clearSearch').on('click',function(){
        $('#search-form').trigger('reset');
    });
});
